import { render, staticRenderFns } from "./placingSuccessfullyPage.vue?vue&type=template&id=3971ebb9&scoped=true&"
import script from "./placingSuccessfullyPage.vue?vue&type=script&lang=js&"
export * from "./placingSuccessfullyPage.vue?vue&type=script&lang=js&"
import style0 from "./placingSuccessfullyPage.vue?vue&type=style&index=0&id=3971ebb9&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3971ebb9",
  null
  
)

export default component.exports